import { FC, useMemo } from "react";
import { BulkActionProps } from "../BulkActionsControls/types";
import useBulkAction from "hooks/useBulkAction";
import { BulkAction } from "../BulkActionsControls/types";
import { trash2 } from "assets/icons";
import BulkActionsControlBase from "../BulkActionsControls/BulkActionsControlBase";
import useDeleteUser from "hooks/services/users/useDeleteUser";
import { useTranslation } from "react-i18next";

const BlockBulkActionControl: FC<BulkActionProps> = (props) => {
  const { mutateAsync: deleteUsersAsync } = useDeleteUser();
  const {
    bulkAction: deleteUserBulk,
    isLoading: isDeletingUserBulk,
    bulkResult: deleteUserBulkResult,
  } = useBulkAction(deleteUsersAsync);

  const { t } = useTranslation();

  const actions: BulkAction[] = useMemo(
    () => [
      {
        name: t("Remove"),
        icon: trash2,
        confirmMessage: t("Are you sure you want to delete these users?"),
        bulkAction: deleteUserBulk,
        bulkActionLoading: isDeletingUserBulk,
        bulkActionResult: deleteUserBulkResult,
      },
    ],
    [deleteUserBulk, isDeletingUserBulk, deleteUserBulkResult]
  );
  return <BulkActionsControlBase {...props} actions={actions} />;
};

export default BlockBulkActionControl;
